import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import WhatsAppSetupModal from "./WhatsAppSetupModal";
import { getSettings, getSettingsErrorMessage } from "../../services/whatsappSetupApi";
import toast from "react-hot-toast";

/**
 * Blocks WhatsApp module pages until tenant Meta credentials are configured.
 */
export default function WhatsAppSetupGate({ children }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [configured, setConfigured] = useState(false);
  const [setupOpen, setSetupOpen] = useState(false);
  const [initialSettings, setInitialSettings] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const settings = await getSettings();
        if (cancelled) return;
        if (settings.configured) {
          setConfigured(true);
        } else {
          setInitialSettings(settings);
          setSetupOpen(true);
        }
      } catch (err) {
        if (!cancelled) {
          toast.error(getSettingsErrorMessage(err, "Failed to check WhatsApp setup"));
          navigate("/dashboard", { replace: true });
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center p-5">
        <Spinner animation="border" role="status" aria-label="Loading WhatsApp" />
      </div>
    );
  }

  if (!configured) {
    return (
      <WhatsAppSetupModal
        show={setupOpen}
        initialSettings={initialSettings}
        onHide={() => navigate("/dashboard", { replace: true })}
        onSuccess={() => {
          setSetupOpen(false);
          setConfigured(true);
          toast.success("WhatsApp connected successfully");
        }}
      />
    );
  }

  return children;
}
